
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TopicCategory"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"topics_Category"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"slug"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"uri"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"topicSimpleHeading"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"topicHeadingOverride"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"topicHideEyebrow"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":143}};
    doc.loc.source = {"body":"fragment TopicCategory on topics_Category {\n  __typename\n  slug\n  uri\n  title\n  topicSimpleHeading\n  topicHeadingOverride\n  topicHideEyebrow\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

      module.exports = doc;
    
